<template>
  <BoxCard>
    <template #header>
      <div class="flex justify-between">
        <p>Attendance</p>
      </div>
    </template>
    <template #content>
      <!-- Cancel application button -->
      <ViceButton
        v-if="showCancelApplicationButton"
        data-cy="cancel-participation"
        class="w-full mb-4"
        small
        red
        icon="XIcon"
        @click="cancelApplication"
      >
        Cancel application
      </ViceButton>
      <div class="mb-5">
        <div class="flex gap-5">
          <div class="p-2.5 rounded-lg bg-indigo-200 h-50">
            <UserIcon class="h-7 w-7 text-vice-medium-blue"></UserIcon>
          </div>
          <div>
            <p class="text-xs leading-6 font-semibold text-vice-medium-blue">Participants</p>
            <div class="flex gap-3 items-end">
              <p class="text-xs font-medium text-dark-grey leading-6">
                <span class="text-xl text-gray-900">
                  <!-- Data from SessionOpenPlacesMixin -->
                  {{ openParticipantsPositions }}
                </span>
                <span>
                  open /
                  <span class="font-bold">
                    <!-- Data from SessionOpenPlacesMixin -->
                    {{ maxParticipantsAmount }}
                  </span>
                  max
                </span>
              </p>
              <!-- Data from SessionOpenPlacesMixin -->
              <div v-if="!currentSessionIsPrivate" class="italic text-gray-600 text-xs leading-6">
                ({{ maxParticipantsAmount - openParticipantsPositions }} applications)
              </div>
            </div>
          </div>
        </div>
        <div class="mt-5" v-if="showApplyAsParticipantButton">
          <ViceButton
            class="w-full"
            small
            indigo
            icon="MailIcon"
            @click="sendApplicationRequest(userType.participant)"
          >
            Apply as participant
          </ViceButton>
        </div>
      </div>
      <div class="relative w-96 mb-5">
        <hr class="absolute right-6 w-full text-gray-200" />
      </div>
      <div class="mt-12">
        <div class="flex gap-5">
          <div
            class="p-2.5 rounded-lg h-50"
            :class="observer_open_position ? 'bg-vice-light-yellow' : 'bg-vice-light-grey'"
          >
            <EyeIcon
              class="h-7 w-7"
              :class="observer_open_position ? 'text-vice-dark-yellow' : 'text-dark-grey'"
            ></EyeIcon>
          </div>
          <div>
            <p
              class="text-xs leading-6 font-semibold"
              :class="observer_open_position ? 'text-vice-dark-yellow' : 'text-dark-grey'"
            >
              Observers
            </p>
            <div class="flex gap-3 items-end">
              <p class="text-xs font-medium text-dark-grey leading-6">
                <span class="text-xl text-gray-900">
                  <!-- Data from SessionOpenPlacesMixin -->
                  {{ openObserversPositions }}
                </span>
                open /
                <span class="font-bold">
                  <!-- Data from SessionOpenPlacesMixin -->
                  {{ maxObserversAmount }}
                </span>
                max
              </p>
              <!-- Data from SessionOpenPlacesMixin -->
              <div v-if="!currentSessionIsPrivate" class="italic text-gray-600 text-xs leading-6">
                ({{ maxObserversAmount - openObserversPositions }} applications)
              </div>
            </div>
          </div>
        </div>
        <div class="mt-5" v-if="showApplyAsObserverButton">
          <ViceButton
            class="w-full"
            small
            yellow
            icon="MailIcon"
            @click="sendApplicationRequest(userType.observer)"
          >
            Apply as observer
          </ViceButton>
        </div>
      </div>
    </template>
  </BoxCard>
</template>

<script>
import { UserIcon, EyeIcon } from '@heroicons/vue/solid';
import { ref } from 'vue';
import axios from 'axios';
import { Inertia } from '@inertiajs/inertia';
import ViceButton from '@/Components/Buttons/ViceButton.vue';
// import ViceBadge from '@/Components/Badges/ViceBadge.vue';
import BoxCard from '@/Components/Cards/BoxCard.vue';
import SessionOpenPlacesMixin from '@/Mixins/SessionOpenPlacesMixin.vue';

export default {
  name: 'Application',
  components: {
    BoxCard,
    UserIcon,
    EyeIcon,
    ViceButton,
    // ViceBadge,
  },
  mixins: [SessionOpenPlacesMixin],
  setup() {
    const open = ref(false);
    const userTypeSelected = ref(null);
    return {
      userType,
      open,
      userTypeSelected,
    };
  },
  mounted() {
    this.setOpenPosition();
  },
  props: {
    showApplyButton: {
      type: Boolean,
      default: true,
    },
    applicationId: {
      type: Number || String,
      default: null,
    },
    userSessionType: String,
  },
  data() {
    return {
      currentSession: this.$page.props.session,
      user_invites: this.$page.props.session.users,
      participant_open_position: '',
      observer_open_position: '',
    };
  },
  computed: {
    showApplyAsParticipantButton() {
      return Boolean(this.$page.props.showApplyAsParticipantButton);
    },
    showApplyAsObserverButton() {
      return Boolean(this.$page.props.showApplyAsObserverButton);
    },
    showCancelApplicationButton() {
      return Boolean(this.$page.props.showCancelApplicationButton);
    },
  },
  methods: {
    sendApplicationRequest(applicationType) {
      axios
        .post(route('session.apply'), {
          uuid: this.$page.props.session.unique_id,
          user_type: applicationType,
        })
        .then((response) => {
          console.log(response);
          // Inertia.reload();
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    },

    cancelApplication() {
      axios
        .post(route('session.cancelApplication'), {
          invitation_id: this.$page.props.invitationId,
        })
        .then((response) => {
          console.log(response);
          // Inertia.reload();
          // TODO: fix the applicationId value after application
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getUserOpenCount(userInvites, maxCount, type) {
      let countUser = 0;
      for (let i = 0; i <= this.user_invites.length; i++) {
        if (userInvites[i]) {
          // eslint-disable-next-line no-unused-expressions, no-plusplus
          userInvites[i].user_type === type ? countUser++ : '';
        }
      }
      return maxCount - countUser;
    },
    setOpenPosition() {
      this.participant_open_position = this.getUserOpenCount(
        this.$page.props.session.users,
        this.$page.props.session.participant_preferences.max_participants_amount,
        userType.participant,
      );
      this.observer_open_position = this.getUserOpenCount(
        this.$page.props.session.users,
        this.$page.props.session.participant_preferences.max_observers_amount,
        userType.observer,
      );
    },
    applySession() {
      this.open = false;
      this.$emit('userHasApplied', this.userTypeSelected);
      axios
        .post(route('session.apply', this.$page.props.session.id), {
          user_type: this.userTypeSelected,
        })
        .then(() => {
          Inertia.reload({ only: [this.$page.props.users] });
          this.hasApplied = true;
        });
    },
    enableApply(openPosition) {
      return this.showApplyButton && openPosition && !this.$page.props.session.is_private;
    },
    showCount(count) {
      return this.$page.props.session.is_private ? 0 : count;
    },
  },
};
</script>

<style scoped>
.h-50 {
  height: 50px;
}
</style>
